import React, { useState, useEffect, forwardRef } from "react";
import { Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import InputGroupControl from "@/components/Common/InputGroup";
import { handleTextBoxChange, capitalizeString } from "@/actions/common";
import GitchaNotAvailableModal from "@/components/Common/GitchaNotAvailableModal";
import ZipCloseIcon from "@/images/zipcode-close-icon.svg";
import {
  clearLocationStatesExceptLatLng,
  createS3Folder,
  createS3FolderForBuyersListingService,
  filterArrayBasedOnKey,
  getLocalityFromZipCode,
} from "@/helpers/common";
import {
  BUY,
  DEFAULT_WANT_AD_MAP_ZOOM,
  MAP_EVENT_CLICK,
  MAP_EVENT_LOCATION_CHANGE,
  MAP_EVENT_MARKER_DRAG,
  SHORT_RENT,
} from "@/constants/common";
import GeoLocation from "@/components/Common/GeoLocation";
import {
  getGeoLocation,
  getGeoLocationLatLong,
  checkGitchaAvailable,
} from "@/services/commonServices";
import "simplebar-react/dist/simplebar.min.css";
import { convertToNumber } from "@/helpers/validations";
import { usePrevious } from "@/hooks/usePrevious";
import SelectDropDown from "@/components/Common/SelectDropDown";
import TextBox from "@/components/Common/TextBox";
import { getRadiusList } from "@/services/wantAdService";
import WantAdGoogleMap from "@/components/MemberWantAd/WantAdGoogleMap";
import FireDisplacedCheckbox from "@/components/Common/v2/FireDisplacedCheckbox";
import { useMemo } from "react";
import { formatAddressForDisplay } from "@/helpers/common";
import { useAppConfig } from "@/appConfig";

const WantAdLocation = forwardRef((props, ref) => {
  const {
    handleFormValues,
    location,
    isEdit = false,
    lat,
    lng,
    mapZoom,
    mapType,
    targetRef,
    mapRadius,
    neighborHood,
    highSchool,
    adType,
    city,
    state,
    county,
    s3Imagefolder,
    session,
    isGitchaAvailable,
    locationCityError,
    locationRadiusError,
    zipCode,
    zipIdValues,
    zipCodeError,
    isFromBuyersListingService,
    client_Want_ad_Id,
    setLocationCityError,
    setLocationError,
    locationError,
    isFromConfirmationPage,
    fireDisplaced,
    mapContainerStyle = {},
  } = props;
  const { tenant } = useAppConfig() || {};
  const defaultMarket = tenant?.defaultMarket;
  const defaultProps = useMemo(
    () => ({
      center: {
        lat: convertToNumber(lat) || defaultMarket?.latitude,
        lng: convertToNumber(lng) || defaultMarket?.longitude,
      },
      zoom: mapZoom || DEFAULT_WANT_AD_MAP_ZOOM,
    }),
    [lat, lng, mapZoom, defaultMarket],
  );

  const [showMarker, setShowMarker] = useState(true);
  const [isClickOrDrag, setClickDrag] = useState(false);
  const [eventType, setEventType] = useState(null);
  const [isCalifornia, setIsCalifornia] = useState(
    state === "CA" ? true : false,
  );
  const HandleMapClickOrDrag = (status) => {
    setClickDrag(status);
  };
  const handleShowMarker = (markerStatus) => {
    setShowMarker(markerStatus);
  };

  const [isDisable, setDisable] = useState(true);
  const [radiusList, setRadiusList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [zipList, setZipList] = useState([]);

  const [gitchaModalShow, setGitchaModal] = useState(false);

  const [zipCodeArray, setZipCodeArray] = useState(
    zipCode?.length > 0 ? zipCode : [],
  );
  const [zipCodeEnterdValue, setZipCodeEnterdValue] = useState(null);
  const [showPolygon, setShowPolygon] = useState(
    zipCode?.length > 0 ? true : false,
  );
  const [isDrawMode, setIsDrawMode] = useState(false);

  useEffect(() => {
    if (zipCode && zipCode?.length > 0) {
      setZipCodeArray(zipCode);
    } else {
      setZipCodeArray([]);
    }
  }, [zipCode]);

  const handleGitchaAvailableModal = (state) => {
    if (state === false) {
      clearLocationStates();
    }
    handleShowMarker(true);
    setGitchaModal(state);
  };

  const handleLocTextBoxDisable = (state) => {
    setDisable(false);
  };

  //Function to get results from address details list from google geocode api
  const getAddresseDetails = async ({ eventType, reqPayload }) => {
    setEventType(eventType);

    await getGeoLocation(reqPayload).then((data) => {
      const results = _.get(data, "results");
      let locArray = [];
      if (results?.length > 0) {
        const formatted_address = _.get(results?.[0], "formatted_address", "");
        if (
          eventType === MAP_EVENT_LOCATION_CHANGE &&
          results?.length > 0 &&
          formatted_address !== "United States"
        ) {
          locArray.push(results[0]);
          setLocationList(locArray);
        }
        const firstLocationResult = _.get(results[0], "geometry.location", "");
        const firstAddressComponent = _.get(
          results[0],
          "address_components",
          "",
        );

        const lat = _.get(firstLocationResult, "lat", "");
        const lng = _.get(firstLocationResult, "lng", "");
        let addressObject = { lat: lat, lng: lng };
        if (
          eventType === MAP_EVENT_CLICK ||
          eventType === MAP_EVENT_MARKER_DRAG
        ) {
          try {
            if (firstAddressComponent && firstAddressComponent.length > 0) {
              const street_no = firstAddressComponent.filter(function (ca) {
                return ca.types?.[0] === "street_number";
              });

              if (street_no?.length) {
                addressObject.street_no = _.get(
                  street_no?.[0],
                  "short_name",
                  "",
                );
              }

              const route = firstAddressComponent.filter(function (ca) {
                return ca.types?.[0] === "route";
              });

              if (route?.length) {
                addressObject.route = _.get(route?.[0], "short_name", "");
                addressObject.street = _.get(route?.[0], "short_name", "");
              }
              const locality = firstAddressComponent.filter(function (ca) {
                if (isCalifornia) {
                  return (
                    ca.types?.[0] === "locality" ||
                    ca.types?.[0] === "administrative_area_level_2"
                  );
                } else {
                  return ca.types?.[0] === "locality";
                }
              });
              if (locality?.length) {
                addressObject.city = _.get(locality?.[0], "long_name", "");
              }
              const county = firstAddressComponent.filter(function (ca) {
                return ca.types?.[0] === "administrative_area_level_2";
              });
              if (county?.length) {
                addressObject.county = _.get(county?.[0], "short_name", "");
              }

              const state = firstAddressComponent.filter(function (ca) {
                return ca.types?.[0] === "administrative_area_level_1";
              });
              if (state?.length) {
                addressObject.state = _.get(state?.[0], "short_name", "");
              }
              const zip = firstAddressComponent.filter(function (ca) {
                return ca.types?.[0] === "postal_code";
              });
              if (zip?.length) {
                addressObject.zip = _.get(zip?.[0], "short_name", "");
              }
            }
          } catch {}
          isGitchaAvailableLocation(addressObject);
          const city = _.get(addressObject, "city", null);
          const state = _.get(addressObject, "state", null);
          if (city && state) {
            addressObject.location = `${city}, ${state}`;
          }
          handleFormValues(addressObject);
        } else {
          handleFormValues(addressObject);
        }
      } else {
        const isDisable = true;
        handleFormValues({ invalidLocation: true });
      }
    });
  };

  //fetch radius lists from api
  const getRadiusLists = async () => {
    await getRadiusList().then((data) => {
      const results = _.get(data, "result");
      if (results?.length > 0) {
        setRadiusList(results);
      } else {
      }
    });
  };

  /**
   * To check if gitcha is available in selected location
   * @param {*} param0
   * @returns
   */
  const checkGitchAvailability = async ({ zip, state, city, county }) => {
    const reqPayLoad = { county: county, state: state };
    return await checkGitchaAvailable(reqPayLoad).then((data) => {
      return data;
    });
  };

  useEffect(() => {
    if (
      !isDrawMode &&
      eventType === MAP_EVENT_LOCATION_CHANGE &&
      isGitchaAvailable &&
      prevMapRadius === mapRadius &&
      !mapRadius &&
      zipCode?.length == 0 &&
      !zipCodeEnterdValue
    ) {
      handleFormValues({ mapRadius: 5, mapZoom: 10 });
    }
    if (location && location !== "" && (mapRadius || isDrawMode) && county) {
      handleFormValues({ invalidLocation: false });
    } else {
      const isDisable = true;
      handleFormValues({ invalidLocation: true });
    }
  }, [location, mapRadius, city, state, isGitchaAvailable, eventType, isDrawMode]);

  useEffect(() => {
    getRadiusLists();
    if (!s3Imagefolder || !isFromConfirmationPage) {
      if (isFromBuyersListingService && client_Want_ad_Id) {
        getFolderNameBuyersLstingService(client_Want_ad_Id);
      } else {
        getFolderName();
      }
    }
  }, []);

  //Create S3 folder name
  const getFolderName = async () => {
    const isWantAd = true;
    await createS3Folder(isWantAd).then(function (result) {
      const folderName = result;
      handleFormValues({ s3ImageFolder: folderName });
    });
  };
  //Create S3 foldername for buyerlisting service
  const getFolderNameBuyersLstingService = async (wantId) => {
    const isWantAd = true;
    await createS3FolderForBuyersListingService(wantId, isWantAd).then(
      function (result) {
        const folderName = result;
        handleFormValues({ s3ImageFolder: folderName });
      },
    );
  };

  const previousLocation = usePrevious(location);
  const prevMapRadius = usePrevious(mapRadius);

  // To handle changes in location text field
  const handleLocationChange = (e) => {
    clearZipCodeList();
    handleFormValues({
      city: "",
      state: "",
      zip: "",
      county: "",
      mapRadius: "",
      neighborHood: "",
      highSchool: "",
      isGitchaAvailable: false,
      zipCode: [],
      zipIdValues: [],
      zipId: [],
      forGitchaAvailablePopup: {},
    });
    setZipCodeArray([]);
    setZipCodeEnterdValue(null);
    const value = capitalizeString(handleTextBoxChange(e));
    const reqPayload = `address=${value}&components=country:US`;
    if (value?.trim() !== "" && value?.length > 3) {
      getAddresseDetails({
        reqPayload: reqPayload,
        eventType: MAP_EVENT_LOCATION_CHANGE,
      });
    } else {
      clearAddressList();
    }
    const isDisableContinueButton = value && value.trim() !== "" ? false : true;
    if (value && value.trim() !== "") {
      handleFormValues({ location: value });
    } else {
      clearLocationStates();
    }
  };
  //To handle clear location states
  const clearLocationStates = () => {
    handleFormValues({
      location: "",
      city: "",
      state: "",
      zip: "",
      county: "",
      lat: "",
      lng: "",
      mapRadius: "",
      isGitchaAvailable: null,
      forGitchaAvailablePopup: {},
    });
  };
  // check gitcha available in location entered
  const isGitchaAvailableLocation = async (addressObject) => {
    const state = _.get(addressObject, "state", "");
    const city = _.get(addressObject, "city", "");
    let county = _.get(addressObject, "county", "");
    if (!county) {
      const reqPayload = `address=${city + ", " + state}`;

      await getGeoLocation(reqPayload).then((data) => {
        const results = _.get(data, "results");

        if (results?.length > 0) {
          const firstAddressComponent = _.get(
            results[0],
            "address_components",
            "",
          );

          try {
            if (firstAddressComponent && firstAddressComponent.length > 0) {
              const countyArray = firstAddressComponent.filter(function (ca) {
                return ca.types?.[0] === "administrative_area_level_2";
              });

              if (countyArray?.length) {
                county = _.get(countyArray?.[0], "short_name", "");
              }
            }
          } catch {}
          handleFormValues({ county: county });
        }
      });
    }
    if (!county) {
      handleFormValues({ isGitchaAvailable: false });
      handleGitchaAvailableModal(true);
      clearZipCodeList();
      setZipCodeEnterdValue("");
    } else {
      checkGitchAvailability({
        county: county,
        state: state,
      }).then((response) => {
        const isGitchaAvailable = _.get(response, "result", "");
        handleFormValues({ isGitchaAvailable: isGitchaAvailable });
        if (!isGitchaAvailable) {
          handleGitchaAvailableModal(true);
          clearZipCodeList();
          setZipCodeEnterdValue("");
        }
      });
    }
  };

  //Handle selection from dropdown shown
  const handleItemSelection = async (address, { fromDraw = false } = {}) => {
    let isCalifornia = false;
    address?.address_components?.map((address) => {
      if (address.long_name === "California") {
        isCalifornia = true;
      }
    });
    setIsCalifornia(isCalifornia);
    clearLocationStatesExceptLatLng(handleFormValues);
    handleShowMarker(true);
    HandleMapClickOrDrag(false);
    const formatted_address = _.get(address, "formatted_address", "");
    const firstAddressComponent = _.get(address, "address_components", "");
    const latitude = _.get(address, "geometry.location.lat", ""); // removeFixedDecimalPart({value: _.get(address, "geometry.location.lat", ""), decimalPoint : DECIMAL_POINTS_IN_COORDICATES});
    const longitude = _.get(address, "geometry.location.lng", ""); // removeFixedDecimalPart({value: _.get(address, "geometry.location.lng", ""), decimalPoint : DECIMAL_POINTS_IN_COORDICATES});

    let addressObject = {
      lat: latitude,
      lng: longitude,
      location: formatted_address?.trim(),
      zipCode: [],
      zipIdValues: [],
      zipId: [],
    };

    const locality = firstAddressComponent.filter(function (ca) {
      if (isCalifornia) {
        return (
          ca.types?.[0] === "locality" ||
          ca.types?.[0] === "administrative_area_level_2"
        );
      } else {
        return ca.types?.[0] === "locality";
      }
    });
    const zip = firstAddressComponent.filter(function (ca) {
      return ca.types?.[0] === "postal_code";
    });
    if (zip?.length) {
      addressObject.zip = _.get(zip?.[0], "short_name", "");
    }
    if (locality?.length) {
      addressObject.city = _.get(locality?.[0], "long_name", "");
    } else {
      await getLocalityFromZipCode(addressObject);
    }

    const state = firstAddressComponent.filter(function (ca) {
      return ca.types?.[0] === "administrative_area_level_1";
    });
    if (state?.length) {
      addressObject.state = _.get(state?.[0], "short_name", "");
    }

    const county = firstAddressComponent.filter(function (ca) {
      return ca.types?.[0] === "administrative_area_level_2";
    });
    if (county?.length) {
      addressObject.county = _.get(county?.[0], "short_name", "");
    }
    const country = firstAddressComponent.filter(function (ca) {
      return ca.types?.[0] === "country";
    });
    if (fromDraw && !addressObject.city && addressObject.county) {
      addressObject.city = addressObject.county;
    }

    addressObject.location = `${addressObject.city}, ${addressObject.state}`;

    if (addressObject?.city == null || addressObject?.city == "") {
      if (!fromDraw) {
        setLocationCityError(true);
        setLocationError("Please enter a valid city and state. ");
      }
      clearAddressList();
    } else {
      setLocationError("");
      setLocationCityError(false);
      isGitchaAvailableLocation(addressObject);
      if (fromDraw) {
        handleFormValues(addressObject);
      } else {
        handleFormValues({ ...addressObject, drawnPolygon: null });
        setZipCodeArray([]);
        setShowPolygon(false);
        setIsDrawMode(false);
      }
      clearAddressList();
    }
  };

  const clearAddressList = () => {
    setLocationList([]);
  };

  const handleZipCodeChange = (e) => {
    setLocationError("");
    setZipCodeEnterdValue(e.target.value);
    handleFormValues({
      location: "",
      city: "",
      state: "",
      zip: "",
      county: "",
      mapRadius: "",
      isGitchaAvailable: false,
      zipCode: zipCode,
    });
    const value = capitalizeString(e.target.value);
    const reqPayload = `address=${value}&components=country:US`;

    if (value?.trim() !== "" && value?.length > 4) {
      getZipDetails({ reqPayload: reqPayload });
    } else {
      clearAddressList();
    }
  };

  const getZipDetails = async ({ eventType, reqPayload }) => {
    clearZipCodeList();
    await getGeoLocation(reqPayload).then((data) => {
      const results = _.get(data, "results");

      if (results?.length > 0) {
        const formatted_address = _.get(results?.[0], "formatted_address", "");

        const firstLocationResult = _.get(results[0], "geometry.location", "");
        const firstAddressComponent = _.get(
          results[0],
          "address_components",
          "",
        );

        const lat = _.get(firstLocationResult, "lat", "");
        const lng = _.get(firstLocationResult, "lng", "");
        let addressObject = { lat: lat, lng: lng };

        try {
          if (firstAddressComponent && firstAddressComponent.length > 0) {
            const street_no = firstAddressComponent.filter(function (ca) {
              return ca.types?.[0] === "street_number";
            });

            if (street_no?.length) {
              addressObject.street_no = _.get(street_no?.[0], "short_name", "");
            }

            const route = firstAddressComponent.filter(function (ca) {
              return ca.types?.[0] === "route";
            });

            if (route?.length) {
              addressObject.route = _.get(route?.[0], "short_name", "");
              addressObject.street = _.get(route?.[0], "short_name", "");
            }
            const locality = firstAddressComponent.filter(function (ca) {
              if (isCalifornia) {
                return (
                  ca.types?.[0] === "locality" ||
                  ca.types?.[0] === "administrative_area_level_2"
                );
              } else {
                return ca.types?.[0] === "locality";
              }
            });
            if (locality?.length) {
              addressObject.city = _.get(locality?.[0], "long_name", "");
            }
            const county = firstAddressComponent.filter(function (ca) {
              return ca.types?.[0] === "administrative_area_level_2";
            });
            if (county?.length) {
              addressObject.county = _.get(county?.[0], "short_name", "");
            }

            const state = firstAddressComponent.filter(function (ca) {
              return ca.types?.[0] === "administrative_area_level_1";
            });
            if (state?.length) {
              addressObject.state = _.get(state?.[0], "short_name", "");
            }
            const zip = firstAddressComponent.filter(function (ca) {
              return ca.types?.[0] === "postal_code";
            });
            if (zip?.length) {
              addressObject.zip = _.get(zip?.[0], "short_name", "");
              results[0].zipCode = _.get(zip?.[0], "short_name", "");
              setZipList(results);
              handleFormValues({ forGitchaAvailablePopup: addressObject });
              isGitchaAvailableLocation(addressObject);
            }
          }
        } catch {}
      } else {
        console.log("error");
      }
    });
  };
  //To handle zipCode selection
  const handleZipCodeItemSelection = async (address) => {
    const exist = zipCodeArray?.find((loc) => loc?.zipCode == address?.zipCode);

    if (!exist) {
      clearZipCodeList();
      setZipCodeArray([
        ...zipCodeArray,
        { zipCode: address?.zipCode, zipId: null },
      ]);
      setZipCodeEnterdValue("");
      const formatted_address = _.get(address, "formatted_address", "");
      const firstAddressComponent = _.get(address, "address_components", "");
      const latitude = _.get(address, "geometry.location.lat", ""); // removeFixedDecimalPart({value: _.get(address, "geometry.location.lat", ""), decimalPoint : DECIMAL_POINTS_IN_COORDICATES});
      const longitude = _.get(address, "geometry.location.lng", ""); // removeFixedDecimalPart({value: _.get(address, "geometry.location.lng", ""), decimalPoint : DECIMAL_POINTS_IN_COORDICATES});

      let addressObject = {
        lat: latitude,
        lng: longitude,
        location: "",
        mapRadius: "",
        zipCode: [...zipCodeArray, { zipCode: address?.zipCode, zipId: null }],
      };
      handleFormValues(addressObject);
      clearZipCodeList();
      setShowPolygon(true);
      setShowMarker(false);
    } else {
      setZipCodeEnterdValue("");
      clearZipCodeList();
    }
  };
  //To handle remove zipcode location
  const handleRemoveLocation = (removeLocation) => {
    const someArray = zipIdValues.filter(
      (loc) => loc?.zipCode != removeLocation?.zipCode,
    );
    handleFormValues({
      zipCode: someArray,
      zipIdValues: someArray,
      focusOut: true,
    });
    setZipCodeArray(someArray);
  };

  const clearZipCodeList = () => {
    setZipList([]);
  };

  const handleToggleDrawMode = () => {
    if (isDrawMode) {
      setIsDrawMode(false);
      handleFormValues({ drawnPolygon: null });
      return;
    }

    setIsDrawMode(true);
    setShowPolygon(false);
    setZipCodeArray([]);
    setZipCodeEnterdValue(null);
    handleFormValues({
      mapRadius: "",
      zipCode: [],
      zipIdValues: [],
      zipId: [],
      drawnPolygon: null,
    });
  };

  const handleDrawComplete = async (coordinates) => {
    const lngSum = coordinates.reduce((sum, p) => sum + p.lng, 0);
    const latSum = coordinates.reduce((sum, p) => sum + p.lat, 0);
    const centroidLng = lngSum / coordinates.length;
    const centroidLat = latSum / coordinates.length;

    handleFormValues({
      drawnPolygon: coordinates,
      lat: centroidLat,
      lng: centroidLng,
    });

    const { addressObject } = await getGeoLocationLatLong(
      centroidLat,
      centroidLng,
    );

    if (addressObject) {
      handleItemSelection(addressObject, { fromDraw: true });
    }
  };

  const handleMapRadiusChanges = (e) => {
    const value = _.get(e, "value", "");
    let zoomLvelBasedOnRadius;

    switch (value) {
      case 1:
        zoomLvelBasedOnRadius = 12;
        break;
      case 5:
        zoomLvelBasedOnRadius = 10;
        break;
      case 10:
        zoomLvelBasedOnRadius = 9;
        break;
      case 15:
        zoomLvelBasedOnRadius = 9;
        break;
      case 20:
        zoomLvelBasedOnRadius = 8;
        break;
      case 25:
        zoomLvelBasedOnRadius = 8;
        break;
      case 30:
        zoomLvelBasedOnRadius = 8;
        break;
      case 50:
        zoomLvelBasedOnRadius = 7;
        break;
    }
    handleFormValues({
      mapRadius: value,
      mapZoom: zoomLvelBasedOnRadius,
      focusOut: true,
    });
  };
  const handleNeighborhoodChange = (e) => {
    const value = capitalizeString(handleTextBoxChange(e));
    handleFormValues({ neighborHood: value });
  };
  const handleHighSchoolChange = (e) => {
    const value = capitalizeString(handleTextBoxChange(e));
    handleFormValues({ highSchool: value });
  };

  const handleCombinedInputChange = (e) => {
    const value = e.target.value;

    // Check if input is a ZIP code (numeric and length 5)
    if (/^\d+$/.test(value) && value?.length <= 5) {
      handleZipCodeChange(e);
    } else {
      handleLocationChange(e);
    }
  };

  return (
    <>
      {!location && !lat && !lng && (
        <GeoLocation handleFormValues={handleFormValues} />
      )}
      <div className={!isEdit ? "center-content-sec mw-100 mt-0 mb-32" : ""}>
        <div className="wantad-location-wrap mb-0">
          <div className="row">
            <div className="col-md-6">
              <div className="common-input-wrap mb-2">
                {!isEdit && (
                  <Form.Label
                    className={`${
                      locationCityError || zipCodeError
                        ? "red-marked-formlabel"
                        : "wanted-info-label"
                    }`}
                  >
                    City or ZIP(s)<span>*</span>
                  </Form.Label>
                )}
                <div className="position-relative">
                  {locationList?.length > 0 ? (
                    <Button
                      variant=""
                      className="search-clear-btn"
                      onClick={() => clearAddressList()}
                    ></Button>
                  ) : (
                    ""
                  )}
                  <InputGroupControl
                    inputGroupClass={
                      locationCityError || zipCodeError
                        ? "wantad-location-search position-relative red-marked-wrap mb-0"
                        : "wantad-location-search position-relative mb-0 want-ad-inputgroup"
                    }
                    ariaLabel="Example"
                    ariaDescribedBy="basic-addon3"
                    placeholder="Enter city and state or ZIP code"
                    errorMessage={locationError}
                    value={zipCodeEnterdValue || location || ""}
                    iconClass="search-icon"
                    isIconEnable={true}
                    iconId="button-addon3"
                    onChange={handleCombinedInputChange}
                    onBlur={() => {
                      handleFormValues({ focusOut: true });
                    }}
                    disabled={!lat && !lng ? true : false}
                  />
                  {locationList?.length > 0 && (
                    <div className="location-result-wrap">
                      <ul>
                        {locationList?.map((address, i) => {
                          return (
                            <li key={i}>
                              <a
                                role="button"
                                href={void 0}
                                onClick={(e) => {
                                  handleItemSelection(address);
                                }}
                              >
                                {formatAddressForDisplay(
                                  _.get(address, "formatted_address", ""),
                                )}
                              </a>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}

                  {/* Show ZIP suggestions */}
                  {zipList?.length > 0 && (
                    <div className="location-result-wrap">
                      <ul>
                        {zipList.map((address, i) => (
                          <li key={i}>
                            <a
                              onClick={() =>
                                handleZipCodeItemSelection(address)
                              }
                            >
                              {address.zipCode}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {/* Show selected ZIP tags */}
                  {zipCodeArray?.length > 0 && (
                    <div className="zipcode-tag-wrap">
                      {zipCodeArray.map((loc, i) => (
                        <div key={i} className="zipcode-tag me-3">
                          <button
                            className="btn zipcode-close-btn me-1"
                            onClick={() => handleRemoveLocation(loc)}
                          >
                            <img src={ZipCloseIcon} alt="remove" />
                          </button>
                          {loc?.zipCode}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="common-input-wrap mb-2">
                <div className="lot-select-wrap">
                  <Form.Label
                    className={
                      locationRadiusError
                        ? "red-marked-formlabel"
                        : "wanted-info-label"
                    }
                  >
                    Radius<span>*</span>
                  </Form.Label>
                  <SelectDropDown
                    name="colors3"
                    options={radiusList || []}
                    className={
                      locationRadiusError
                        ? "lotsize-select want-ad-inputradius red-marked-formcontrol"
                        : "lotsize-select want-ad-inputradius"
                    }
                    classNamePrefix="select"
                    placeholder="Select mile radius"
                    value={filterArrayBasedOnKey({
                      list: radiusList,
                      filterKey: "value",
                      value: mapRadius,
                    })}
                    onChange={(e) => handleMapRadiusChanges(e)}
                    components={{
                      DropdownIndicator: () => null,
                      IndicatorSeparator: () => null,
                    }}
                    styles={{
                      dropdownIndicator: (provided, state) => ({
                        ...provided,
                        transform:
                          state.selectProps.menuIsOpen && "rotate(180deg)",
                      }),
                    }}
                    errorClass="error-msg error-msg-height"
                    disabled={isDrawMode || (zipCodeArray && zipCodeArray.length > 0)}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="common-input-wrap mb-2">
                <Form.Label className="wanted-info-label">
                  Preferred Neighborhood
                </Form.Label>
                <TextBox
                  type="text"
                  value={neighborHood}
                  onChange={(e) => {
                    handleNeighborhoodChange(e);
                  }}
                  placeholder="Neighborhood"
                  disabled={location == "" && zipCode?.length == 0}
                  onBlur={() => {
                    handleFormValues({ focusOut: true });
                  }}
                  className="want-ad-input"
                ></TextBox>
              </div>
            </div>
            {adType !== SHORT_RENT && (
              <div className="col-md-6">
                <div className="common-input-wrap mb-2">
                  <Form.Label className="wanted-info-label">
                    Preferred High School
                  </Form.Label>
                  <TextBox
                    type="text"
                    value={highSchool}
                    onChange={(e) => {
                      handleHighSchoolChange(e);
                    }}
                    placeholder="High School"
                    disabled={location == "" && zipCode?.length == 0}
                    onBlur={() => {
                      handleFormValues({ focusOut: true });
                    }}
                    className="want-ad-input"
                  ></TextBox>
                </div>
              </div>
            )}
            {isCalifornia ? (
              <div className="col-md-12">
                <div className="common-input-wrap mb-2">
                  {adType === BUY ? (
                    <Form.Label>
                      Have you been impacted by the recent LA fires?.
                    </Form.Label>
                  ) : (
                    <Form.Label>
                      Have you been impacted by recent natural disasters? We're
                      here to help.
                    </Form.Label>
                  )}
                  <FireDisplacedCheckbox
                    isChecked={fireDisplaced}
                    handleFormValues={handleFormValues}
                  />
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>

          <div className="d-flex justify-content-end mb-2">
            <Button
              variant="outline-primary"
              size="sm"
              onClick={handleToggleDrawMode}
              disabled={!lat && !lng}
            >
              {isDrawMode ? "Cancel Draw" : "Draw Area"}
            </Button>
          </div>

          <div className="googlemap-responsive" style={mapContainerStyle}>
            <div className="map-outer" ref={targetRef}>
              <WantAdGoogleMap
                ref={ref}
                defaultProps={defaultProps}
                mapHeight="100%"
                mapWidth="100%"
                handleFormValues={handleFormValues}
                mapType={mapType}
                mapRadius={isDrawMode ? null : mapRadius}
                handleShowMarker={handleShowMarker}
                HandleMapClickOrDrag={HandleMapClickOrDrag}
                isClickOrDrag={isClickOrDrag}
                showMarker={showMarker}
                getAddresseDetails={getAddresseDetails}
                handleLocTextBoxDisable={handleLocTextBoxDisable}
                showPolygon={isDrawMode ? false : showPolygon}
                zipCode={isDrawMode ? [] : zipCode}
                zipIdValues={zipIdValues}
                handleItemSelection={handleItemSelection}
                drawMode={isDrawMode}
                onDrawComplete={handleDrawComplete}
              />
            </div>
          </div>
          {!isDrawMode && !zipCode?.length > 0 && (
            <div className="google-map-label mb-24">
              Drag location pin to your desired area
            </div>
          )}
        </div>
        <GitchaNotAvailableModal
          show={gitchaModalShow}
          onHide={() => handleGitchaAvailableModal(false)}
        />
      </div>
    </>
  );
});

export default WantAdLocation;
